/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Minimum_Guarantee_NoteInputs */

const et_plan_minimum_guarantee_note = /** @type {(inputs: Plan_Minimum_Guarantee_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garantii puudub`)
};

const en_plan_minimum_guarantee_note = /** @type {(inputs: Plan_Minimum_Guarantee_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No guarantee`)
};

/**
* | output |
* | --- |
* | "No guarantee" |
*
* @param {Plan_Minimum_Guarantee_NoteInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_minimum_guarantee_note = /** @type {((inputs?: Plan_Minimum_Guarantee_NoteInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Minimum_Guarantee_NoteInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_minimum_guarantee_note(inputs)
	return en_plan_minimum_guarantee_note(inputs)
});